import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.BudgetsPage.BudgetListWrapper', {
    errorMessage: 'Something went wrong. Try reloading the page.',
});
